export default __webpack_public_path__ + "static/favicon-a84c1a2ee3c6dfdd73328154bf3479f7.png";